export default "__VITE_ASSET__e3L6Wx3u__"